import React from 'react'
import logo from '../assets/images/logo.png'
import Button from '../components/Button'
import {Link} from 'react-router-dom'


const ForgetPassword = () => {
  return (
    <>
      <div className='login-background'>
        <div>
          <div className='form-container mt-24'>
            <form action="" className='form-background'>
              <img src={logo} alt="laundry basket logo" className='logo'/>
              <h1 className='login-title'>Password recovery</h1>
              <p className='login-subtitle'>We’ll send a recovery link to your email</p>
              <div className='flex flex-col w-96 gap-10 input-container'>
                <label htmlFor="">
                    <p className='input-label'>Email Address</p> 
                    <input type='text' placeholder='Enter your email' className='input-style'/>
                </label>
            
              </div>
              <Link to='/' style={{width: '100%'}}>
                <Button style={{width: '100%'}}> Send recovery link</Button>
              </Link>
              <Link to='/login' style={{width: '100%'}}>
                <Button style={{background: 'none', width: '100%', color: '#434C5A' }}>I remember my password</Button>
              </Link>
              
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default ForgetPassword